export default {
  data() {
    return {
      langs: this.availableLocales,
      showLogo: false,
      show: true,
    };
  },
  computed: {
    favoritesLength() {
      let favorites = [];

      if (this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          album.items.forEach((photo) => {
            favorites.push(photo);
          });
        });
      }

      return favorites.length;
    },
  },
  methods: {
    goTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path);
      }
    },
    setLocale(locale) {
      //this.$i18n.locale = localStorage.locale = locale;

      if (this.$i18n.locale !== locale) {
        this.$router.push({
          params: {lang: locale},
        });
      }
    },
    isActiveRoute(path) {
      return this.currentRoutePath.replace(/\/$/, '') === path;
    },
  },
};
